// Client-side motive metadata (icons, colors, descriptions)
import {
  Flame,
  Users,
  Star,
  BookOpen,
  Timer,
  Shield,
  Sparkles,
  Zap,
  Rocket,
  Anchor,
  Brain,
  TrendingUp,
} from "lucide-react";

const ICONS = {
  Flame,
  Users,
  Star,
  BookOpen,
  Timer,
  Shield,
  Sparkles,
  Zap,
  Rocket,
  Anchor,
  Brain,
  TrendingUp,
};

export function getMotiveIcon(iconName) {
  return ICONS[iconName] || Star;
}

export function scoreBand(score) {
  if (score >= 75) return { label: "sehr hoch", color: "#CCFF00" };
  if (score >= 60) return { label: "hoch", color: "#00F0FF" };
  if (score >= 40) return { label: "durchschnittlich", color: "#94A3B8" };
  if (score >= 25) return { label: "niedrig", color: "#F59E0B" };
  return { label: "sehr niedrig", color: "#FF3B30" };
}
